import { useQuery } from "@tanstack/react-query";

import { findAppsQueryKeys } from "app/pages/sales-intelligence/modules/find-apps-filters/queries/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export default function useFindAppsDescriptionQuery() {
    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: findAppsQueryKeys.description(),
        queryFn({ signal }) {
            return salesApiService.findApps.fetchDescription({ cancellation: signal });
        },
    });
}
